// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-665ba6a6] .el-form-item {\n  margin-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
